// extracted by mini-css-extract-plugin
export default {"f":"_09bd9ccaa2","main":"bdb0c91f07","btn":"_93eb2f48a6","w":"b317e759aa","h":"_7de3512b68","lh25":"_446df88243","wb":"c3ed2fadd8","b":"_1b0e6fcdf9","bx":"a8e976a166"};